import { render } from "./OrganizationsPicker.vue?vue&type=template&id=80b771c2&ts=true"
import script from "./OrganizationsPicker.vue?vue&type=script&lang=ts"
export * from "./OrganizationsPicker.vue?vue&type=script&lang=ts"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__